import { openUrlInNewTab } from '@ardoq/common-helpers';
import type { UrlFieldValue } from '@ardoq/graph';
import { trackUrlLinkClickedInElement } from './tracking';

const openSingleUrlFieldValue = (
  urlFieldValues: UrlFieldValue[],
  clickedElement: Element
): void => {
  if (urlFieldValues.length !== 1) {
    return;
  }
  trackUrlLinkClickedInElement(clickedElement);
  openUrlInNewTab(urlFieldValues[0].url);
};

export { openSingleUrlFieldValue };
